export default function Marquee({ text, dark = true }) {
  const items = Array(4).fill(text || "The Brides of India");
  return (
    <div
      data-testid="editorial-marquee"
      className={`overflow-hidden py-4 border-y select-none ${
        dark ? "bg-ink text-cream border-champagne/20" : "bg-blush text-ink border-gold/20"
      }`}
    >
      <div className="marquee-track flex whitespace-nowrap w-max">
        {[...items, ...items].map((t, i) => (
          <span key={i} className="font-elegant italic text-lg md:text-xl tracking-wide flex items-center">
            <span className="px-6">{t}</span>
            <span className="text-champagne text-sm">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
